module.exports = __webpack_public_path__ + "739d1ec359e75310da447e9faa20af22.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/zombie-stitches.png
// module id = 1961
// module chunks = 0